(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lrdm-product-arrival"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lrdm-scroll-buy]').forEach((button) => {
    button.addEventListener('click', () => {
      const sectionWrapper = button.closest('.shopify-section');
      sectionWrapper?.nextElementSibling?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrdm-product-editorial"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-lrdm-product]')

  sections.forEach((section) => {
    const gallery = section.querySelector('[data-gallery]')
    const slides = Array.from(section.querySelectorAll('.lrdm-product__slide'))
    const dots = Array.from(section.querySelectorAll('.lrdm-product__dots span'))
    const previous = section.querySelector('[data-gallery-previous]')
    const next = section.querySelector('[data-gallery-next]')
    const form = section.querySelector('[data-product-form]')
    const variantInput = section.querySelector('[data-variant-id]')
    const price = section.querySelector('[data-product-price]')
    const comparePrice = section.querySelector('[data-product-compare-price]')
    const stickyPrice = section.querySelector('[data-sticky-price]')
    const stickyBuy = section.querySelector('[data-sticky-buy]')
    const stickyAction = section.querySelector('[data-sticky-action]')
    const buyCard = section.querySelector('.lrdm-product__buy-card')
    const sizes = section.querySelector('.lrdm-product__sizes')
    const editorialRouteInput = section.querySelector('[data-editorial-route-input]')
    const contextLinks = Array.from(section.querySelectorAll('[data-editorial-context-link]'))
    const routeParams = new URLSearchParams(window.location.search)
    const rawEditorialRoute = (routeParams.get('chapter') || routeParams.get('view') || '').toLowerCase()
    const editorialChapter = rawEditorialRoute.includes('canal')
      ? 'canal-house'
      : (rawEditorialRoute.includes('forest') || rawEditorialRoute.includes('woodland') || rawEditorialRoute.includes('heath'))
        ? 'forest'
        : 'default'
    const galleryVariant = section.dataset.galleryVariant || 'standard'
    const analyticsPayload = {
      editorial_chapter: editorialChapter,
      gallery_variant: galleryVariant,
      item_id: section.dataset.productId || '',
      item_handle: section.dataset.productHandle || '',
      item_name: section.dataset.productTitle || '',
      item_colour: section.querySelector('.lrdm-product__colour-name')?.textContent?.trim() || ''
    }
    let sizeWasChosen = false

    if (editorialRouteInput) editorialRouteInput.value = editorialChapter

    contextLinks.forEach((link) => {
      try {
        const target = new URL(link.href, window.location.origin)
        target.searchParams.set('chapter', editorialChapter)
        link.href = target.toString()
      } catch (_) {}
    })

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'lrdm_editorial_product_view',
      ...analyticsPayload,
      ecommerce: {
        items: [{
          item_id: analyticsPayload.item_id,
          item_name: analyticsPayload.item_name,
          item_variant: analyticsPayload.item_colour
        }]
      }
    })

    try {
      const publishedEvent = window.Shopify?.analytics?.publish?.('lrdm:editorial_product_view', analyticsPayload)
      publishedEvent?.catch?.(() => {})
    } catch (_) {}

    form?.addEventListener('submit', () => {
      const selectedRadio = form.querySelector('input[type="radio"]:checked')
      const addPayload = {
        ...analyticsPayload,
        variant_id: variantInput?.value || selectedRadio?.value || '',
        variant_label: section.querySelector('[data-length-selection]')?.textContent?.trim() || selectedRadio?.nextElementSibling?.textContent?.trim() || ''
      }
      window.dataLayer.push({
        event: 'lrdm_editorial_add_to_cart',
        ...addPayload,
        ecommerce: {
          items: [{
            item_id: addPayload.item_id,
            item_name: addPayload.item_name,
            item_variant: addPayload.item_colour,
            item_category2: addPayload.editorial_chapter
          }]
        }
      })
      try {
        const publishedEvent = window.Shopify?.analytics?.publish?.('lrdm:editorial_add_to_cart', addPayload)
        publishedEvent?.catch?.(() => {})
      } catch (_) {}
    })

    if (gallery && slides.length > 1) {
      let current = 0

      const syncVideos = () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        slides.forEach((slide, index) => {
          const video = slide.querySelector('video')
          if (!video) return
          video.muted = true
          if (reduceMotion) {
            video.controls = true
            video.pause()
          } else if (index === current) {
            video.play().catch(() => {})
          } else {
            video.pause()
          }
        })
      }

      const goTo = (index) => {
        current = (index + slides.length) % slides.length
        slides[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current))
        syncVideos()
      }

      previous?.addEventListener('click', () => goTo(current - 1))
      next?.addEventListener('click', () => goTo(current + 1))

      gallery.addEventListener('scrollend', () => {
        const galleryLeft = gallery.getBoundingClientRect().left
        current = slides.reduce((nearest, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - galleryLeft)
          return distance < nearest.distance ? { index, distance } : nearest
        }, { index: 0, distance: Infinity }).index
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current))
        syncVideos()
      })

      syncVideos()
    }

    const lengthData = section.querySelector('[data-length-options]')
    if (lengthData) {
      const config = JSON.parse(lengthData.textContent)
      if (!config.showLength) config.variants = config.variants.filter(v => v.options[config.lengthIndex] === 'Regular')
      const sizeInputs = Array.from(form.querySelectorAll('[data-length-size]'))
      const lengthInputs = Array.from(form.querySelectorAll('[data-length-choice]'))
      const addButton = form.querySelector('[name="add"]')
      const addLabel = addButton.querySelector('span')
      const hint = form.querySelector('[data-length-hint]')
      const selection = form.querySelector('[data-length-selection]')
      const initial = config.variants.find(v => String(v.id) === new URL(window.location.href).searchParams.get('variant'))
      let chosenSize = initial?.options[config.sizeIndex] || ''
      let chosenLength = config.showLength ? initial?.options[config.lengthIndex] || '' : 'Regular'
      const resolve = () => config.variants.find(v => v.options[config.sizeIndex] === chosenSize && v.options[config.lengthIndex] === chosenLength)
      function syncLengthSelection(updateUrl = true) {
        const variant = resolve()
        sizeInputs.forEach(input => {
          const matches = config.variants.filter(v => v.options[config.sizeIndex] === input.value && (!chosenLength || v.options[config.lengthIndex] === chosenLength))
          input.disabled = !matches.length
          input.closest('label').hidden = !matches.length
          input.closest('label').classList.toggle('is-unavailable', matches.length > 0 && !matches.some(v => v.available))
          input.checked = input.value === chosenSize
        })
        lengthInputs.forEach(input => { input.checked = input.value === chosenLength })
        const text = !chosenSize ? config.chooseSize : !chosenLength ? config.chooseLength : !variant ? config.unavailable : !variant.available ? config.soldOut : section.dataset.addLabel
        addLabel.textContent = text
        addButton.disabled = !variant?.available
        stickyAction.textContent = text
        stickyAction.disabled = Boolean(chosenSize && chosenLength && !variant?.available)
        variantInput.value = variant ? String(variant.id) : ''
        variantInput.disabled = !variant?.available
        sizeWasChosen = Boolean(variant?.available)
        hint.textContent = chosenLength === 'Long' ? config.longHint : chosenLength === 'Regular' ? config.regularHint : config.chooseLength
        selection.textContent = (config.showLength ? [chosenLength, chosenSize].filter(Boolean).join(' · ') : chosenSize) + (variant && !variant.available ? ' — ' + config.soldOut : '')
        if (variant) {
          price.textContent = variant.price
          if (stickyPrice) stickyPrice.textContent = variant.price
          if (comparePrice) { comparePrice.textContent = variant.comparePrice; comparePrice.hidden = !variant.comparePrice }
        }
        if (updateUrl) {
          const nextUrl = new URL(window.location.href)
          if (variant) nextUrl.searchParams.set('variant', variant.id)
          else nextUrl.searchParams.delete('variant')
          window.history.replaceState({}, '', nextUrl)
        }
      }
      sizeInputs.forEach(input => input.addEventListener('change', () => { chosenSize = input.value; syncLengthSelection() }))
      lengthInputs.forEach(input => input.addEventListener('change', () => {
        chosenLength = input.value
        if (chosenSize && !resolve()) chosenSize = ''
        syncLengthSelection()
      }))
      form.addEventListener('submit', event => {
        if (!resolve()?.available) { event.preventDefault(); event.stopImmediatePropagation(); syncLengthSelection() }
      }, true)
      syncLengthSelection(false)
    } else {
    form?.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (variantInput) variantInput.value = radio.value
        if (price) price.textContent = radio.dataset.variantPrice || price.textContent
        if (comparePrice) {
          const nextComparePrice = radio.dataset.variantComparePrice || ''
          comparePrice.textContent = nextComparePrice
          comparePrice.hidden = !nextComparePrice
        }
        if (stickyPrice) stickyPrice.textContent = radio.dataset.variantPrice || stickyPrice.textContent
        sizeWasChosen = true
        if (stickyAction) stickyAction.textContent = section.dataset.addLabel
      })
    })

    }

    if (stickyBuy && buyCard) {
      const buyCardObserver = new IntersectionObserver(([entry]) => {
        stickyBuy.classList.toggle('is-visible', !entry.isIntersecting)
      }, { threshold: 0.15 })
      buyCardObserver.observe(buyCard)
    }

    stickyAction?.addEventListener('click', () => {
      if (lengthData && !sizeWasChosen) {
        const target = form.querySelector('[data-length-size]:checked') ? form.querySelector('.lrdm-length__choices') : sizes
        target?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }
      if (sizeWasChosen || !sizes) {
        form?.requestSubmit()
      } else {
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrdm-set-editorial"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lrdm-set]').forEach((section) => {
    const form = section.querySelector('[data-set-form]');
    if (!form) return;
    const variantId = form.querySelector('[data-set-variant-id]');
    const price = section.querySelector('[data-set-price]');
    const compare = section.querySelector('[data-set-compare]');
    form.querySelectorAll('[data-set-variant]').forEach((input) => {
      input.addEventListener('change', () => {
        variantId.value = input.value;
        if (price) price.textContent = input.dataset.price;
        if (compare && input.dataset.compare) compare.textContent = input.dataset.compare;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
